const CONFETTI_COLORS = ['#7bbd8e', '#303030', '#ffae00', '#7bbd8e', '#303030'];
const CONFETTI_PIECE_COUNT = 34;

function createConfettiPiece(index, random = Math.random) {
    const piece = document.createElement('span');
    const width = 5 + Math.round(random() * 5);
    const height = 11 + Math.round(random() * 9);

    piece.className = 'newsletter-confirmation__confetti-piece';
    piece.style.left = `${4 + random() * 92}%`;
    piece.style.width = `${width}px`;
    piece.style.height = `${height}px`;
    piece.style.setProperty('--confetti-color', CONFETTI_COLORS[index % CONFETTI_COLORS.length]);
    piece.style.setProperty('--confetti-drift', `${(random() - 0.5) * 120}px`);
    piece.style.setProperty('--confetti-spin', `${(random() - 0.5) * 900}deg`);
    piece.style.setProperty('--confetti-delay', `${random() * 0.35}s`);
    piece.style.setProperty('--confetti-duration', `${1.1 + random() * 0.7}s`);

    return piece;
}

function attachNewsletterConfirmationConfetti(root = document, random = Math.random) {
    const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
    if (prefersReducedMotion) return;

    root.querySelectorAll('[data-newsletter-confirmation-confetti]').forEach((container) => {
        if (container.dataset.confettiInitialized === 'true') return;

        container.dataset.confettiInitialized = 'true';
        const fragment = document.createDocumentFragment();

        for (let index = 0; index < CONFETTI_PIECE_COUNT; index += 1) {
            fragment.append(createConfettiPiece(index, random));
        }

        container.append(fragment);
    });
}

export { attachNewsletterConfirmationConfetti, createConfettiPiece };
